import { Box, TextField } from '@mui/material';

import {
  JobDetails,
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

export const JobDetailsForm = () => {
  const dispatch = useAppDispatch();
  const stepInputs = useAppSelector(selectOnboardingStepInputs);
  const { value: form } = stepInputs[STEP_IDS.b2cJobDetails];

  const handleChange = (id: keyof JobDetails, value: string) => {
    dispatch(
      onboardingActions.updateStepInputs({
        step: STEP_IDS.b2cJobDetails,
        input: {
          ...form,
          [id]: value,
        },
      }),
    );
  };

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} Subtitle={<Subtitle />} />
      <Box
        sx={[
          styles.formPrimarySection,
          {
            display: 'flex',
            flexDirection: 'column',
          },
        ]}>
        <TextField
          id={'companyName'}
          label="Company Name"
          variant="outlined"
          onChange={e => handleChange('companyName', e.target.value)}
          value={form.companyName}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          id={'jobTitle'}
          label="Job Title"
          variant="outlined"
          onChange={e => handleChange('jobTitle', e.target.value)}
          value={form.jobTitle}
          fullWidth
        />
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => <ModalTitle>Build your profile</ModalTitle>;

const Subtitle = () => (
  <ModalSubtitle>
    Add more information about your current role to your LumiQ profile.
  </ModalSubtitle>
);
